import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const revokeInviteFromOrganization = (id: string, inviteUuid: string): ReturnType => {
    return Request.post(`/organizations/${id}/invites/${inviteUuid}/revoke`);
};

export default revokeInviteFromOrganization;
